export default __webpack_public_path__ + "static/media/search-folder.2a9618fa.png";